import { useContext, useEffect, useState } from "react";
import { RootContext } from "../../../providers/RootProvider";
import PoolRanking from "../../ranking/components/PoolRanking/PoolRanking";
import PoolGames from "../../games/components/PoolGames/PoolGames";

const LoadingBar = ({ time }: { time: number }) => {
  const [progress, setProgress] = useState(0);
  const valueUnit = 100 / time;

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prevProgress) => {
        const newProgress = prevProgress + valueUnit;
        if (newProgress >= 100) {
          setProgress(0);
        }
        return newProgress;
      });

      return () => {
        clearInterval(interval);
      };
    }, 1000);

    return () => clearInterval(interval);
  }, [valueUnit]);

  return (
    <div className="mb-5 h-2 overflow-hidden bg-gray-200">
      <div
        className="h-2 animate-pulse bg-gray-800 ease-linear duration-1000"
        style={{ width: `${progress}%` }}
      />
    </div>
  );
};

const DELAY_SECONDS = 10;
const DELAY = DELAY_SECONDS * 1000; // 10 seconds

export default function TVPage() {
  const {
    pools,
    games,
    ranking,
    categories,
    selectedCategory,
    setSelectedCategory,
  } = useContext(RootContext);
  const [selectedPool, setSelectedPool] = useState(pools?.[0]);
  const selectedGames = games?.find((pool) => pool.name === selectedPool);
  const selectedRanking = ranking?.find((pool) => pool.name === selectedPool);

  // Auto switch pool every 10 seconds and category when all pools are shown
  useEffect(() => {
    if (!pools || !categories) {
      return;
    }

    const interval = setInterval(() => {
      setSelectedPool((prevPool) => {
        if (!prevPool) {
          return pools[0];
        }

        const currentPoolIndex = pools.indexOf(prevPool);
        if (currentPoolIndex === pools.length - 1) {
          // We've shown all pools in the current category
          const currentCategoryIndex = categories.indexOf(
            selectedCategory || ""
          );
          const nextCategoryIndex =
            (currentCategoryIndex + 1) % categories.length;
          setSelectedCategory(categories[nextCategoryIndex]);
          return pools[0]; // Start with the first pool of the new category
        }

        return pools[currentPoolIndex + 1];
      });
    }, DELAY);

    return () => clearInterval(interval);
  }, [pools, categories, selectedCategory, setSelectedCategory]);

  return (
    <div>
      <LoadingBar time={DELAY_SECONDS} />
      <div className="flex flex-col gap-4 p-4">
        <div className="flex flex-col gap-2">
          <h1 className="text-2xl font-bold">
            {selectedCategory} - {selectedPool}
          </h1>
        </div>
        <div className="grid grid-cols-2 gap-4">
          {selectedGames ? (
            <PoolGames pool={selectedGames} onGameClick={() => null} />
          ) : null}
          {selectedRanking ? <PoolRanking pool={selectedRanking} /> : null}
        </div>
      </div>
    </div>
  );
}
